import React, { useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { Stepper as MUIStepper, Step, StepLabel } from '@material-ui/core';
import { Done } from '@material-ui/icons';
import { Wrapper, MobileStepper, Icon, MobileStep } from './Stepper.styles';

export const Stepper = ({steps, current}: {steps: string[], current: number}) => {
  const wrapper = useRef<HTMLDivElement>(null);
  return (
    <>
      {isMobile ?
        <MobileStepper ref={wrapper}>
          {steps.map((label, index) =>
            <MobileStep key={label} step={index} active={current <= index ? true : false} size={sessionStorage.getItem('width') || '320'}>
              <Icon active={current === index ? true : false} done={current > index ? true : false}>
                {current > index ? <Done /> : index + 1}
              </Icon>
              {index !== 4 && <div className="line"></div>}
              {index === current && <p>{label}</p>}
            </MobileStep>
          )}
        </MobileStepper>
        :
        <Wrapper>
          <MUIStepper activeStep={current} orientation={isMobile ? 'horizontal' : 'vertical'}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </MUIStepper>
        </Wrapper>
      }
    </>
  );
}